export default __webpack_public_path__ + "static/immigration-hero-ced3b96a8c6fc5ce363ad6d09c547832.webp";